export default {
  menu_header_home: "Inicio",
  menu_header_projects: "Proyectos",
  menu_header_about: "Nosotros",
  menu_header_contact: "Contacto",
  menu_header_for_sale: "En venta",


  banner_header: "Habitat 3.0 Life Re-Imagined",
  banner_sub: "Redefining the Future of Residential Development in Mexico and Beyond",
  banner_button: "Explora nuestro trabajo",

  projects_title: "Nuestros proyectos",


  services_title: "Nuestros servicios",


  services_bienes: "Si buscas comprar, vender o invertir, te ayudamos a navegar el mercado inmobiliario con asesoramiento experto, conectándote con las mejores oportunidades en la Península de Yucatán. ¡Contáctanos! ",
  services_building: " Ya sea renovando tu hogar actual o comenzando desde cero, nuestro equipo experto transforma tu visión en realidad. Desde mejoras modernas hasta renovaciones completas y casas personalizadas, priorizamos la salud, sostenibilidad, comodidad y funcionalidad en cada proyecto.",
  services_design: " Desde viviendas privadas hasta comunidades y proyectos comerciales a gran escala, nos especializamos en construcción ecológica, diseño funcional y tecnología avanzada para crear espacios saludables, inteligentes y energéticamente eficientes, adaptados a tus necesidades. ¡Contáctanos!",
  services_maquirent: "¿Necesitas las herramientas adecuadas para tu proyecto de construcción o renovación? Maquirent ofrece una amplia selección de herramientas de construcción de alta calidad y grado profesional en alquiler, ayudando a propietarios, constructores y contratistas a completar sus proyectos de manera eficiente. ¡Contáctanos!",

  services_bienes_title: "Bienes Raíces y Soluciones Inmobiliarias",
  services_building_title: "Renovaciones y Construcciones Personalizadas",
  services_design_title: "Diseño y Construcción Sostenible",
  services_rent_title: "Maquirent – Alquiler de Herramientas de Construcción",

  about_us: "Sobre Nosotros",
  about_us_description: "Con 25 años de experiencia en construcción en Yucatán, México,nuestro equipo incluye un profesional certificado en LEED y WELL AP, un ingeniero civil y un experto en diseño de productos y comunicaciones. Juntos, garantizamos el desarrollo de proyectos sostenibles, innovadores y bien comunicados.",

}
